import { useFlag } from 'lane-shared/hooks';

import { FeatureFlag } from 'constants-flags';

export function useInspectionsTemplateCustomizeReorderEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.InspectionsTemplateCustomizeReorder,
    false
  );

  return Boolean(isEnabled);
}
